import service from './request'

/**
 * 获取工单延期申请列表信息
 */
 export const orderExtensionGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/order/extension/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单延期申请信息
 */
 export const orderExtensionGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/extension/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单延期审批处理
 */
 export const orderExtensionApplyHandle = data => {
  return service({
      showLoading: false,
      url: '/crm/order/extension/applyHandle',
      method: 'post',
      type: 'body',
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/orderExamine.js